// Native select in a .select wrapper with a CSS chevron (DESIGN_SPEC §10.7).
//   <Select value onChange options label className? {...select attrs} />   options: { value, label, disabled? }[]
import type { ReactNode, SelectHTMLAttributes } from "react";
import { cx } from "./cx";

export type SelectOption<T extends string> = { value: T; label: ReactNode; disabled?: boolean };

type SelectProps<T extends string> = Omit<SelectHTMLAttributes<HTMLSelectElement>, "value" | "onChange" | "children"> & {
  value: T;
  onChange: (value: T) => void;
  options: readonly SelectOption<T>[];
  label: string;
};

export function Select<T extends string>({ value, onChange, options, label, className, ...rest }: SelectProps<T>) {
  return (
    <span className={cx("select", className)}>
      <select value={value} aria-label={label} onChange={(e) => onChange(e.target.value as T)} {...rest}>
        {options.map((o) => (
          <option key={o.value} value={o.value} disabled={o.disabled}>
            {o.label}
          </option>
        ))}
      </select>
    </span>
  );
}
